import { useMemo } from 'react';
import {
  AppsDockControlCapability,
  type Specs,
} from '@doxyme/extensions-bridge';
import {
  useAddCapability,
  useBasicObservable,
} from '@doxyme/extensions-bridge-react';
import { type AppsDockControl } from '@doxyme/ui/components/foundations';
import { bridge } from '../../../features/extensions/instances';
import { TrackedEvents } from '../../../features/tracking';
import { useTrack } from '../../useTrack';

type Control = Specs.Control.Control;
type UseExtensionsAppsDockControlReturnType = AppsDockControl[];
/**
 * Hook responsible for providing ability to render extension controls to the Extensions SDK
 */
export function useExtensionsAppsDockControl(): UseExtensionsAppsDockControlReturnType {
  const track = useTrack();
  const appsDockControl = useAddCapability(
    bridge,
    () => new AppsDockControlCapability(),
  );

  const [controls] = useBasicObservable<Control[]>(appsDockControl.controls);

  const controlList = useMemo(
    () =>
      controls.map((control: Specs.Control.Control) => ({
        ...control,

        onClick: (): void => {
          void track(TrackedEvents.ButtonClicked, {
            buttonAction: `${control.label} Extension Launched`,
          });

          control.onClick();
        },
      })),
    [controls],
  );

  return controlList as AppsDockControl[];
}
